/**
 * Asks once, on Mojo Up AI Cloud with usage statistics on, whether pages may be counted; the tag
 * loads only after a yes (analytics.ts). Floats at the foot of the window, signed in or out, until
 * answered; Settings → Privacy changes the answer later. Also sends a page view on each move.
 */

import { useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';

import { analyticsOffered, pageView, setUsageConsent, startAnalytics, subscribeAnalytics, usageConsent } from '../../analytics.ts';
import { Button } from '../ui.tsx';

export function UsageConsent() {
  const { pathname } = useLocation();
  const offered = useSyncExternalStore(subscribeAnalytics, analyticsOffered);
  const consent = useSyncExternalStore(subscribeAnalytics, usageConsent);
  useEffect(() => {
    void startAnalytics();
  }, []);
  useEffect(() => {
    pageView(pathname);
  }, [pathname]);
  if (!offered || consent) return null;
  return (
    <div role="region" aria-label="Usage statistics" className="fixed inset-x-0 bottom-0 z-50 flex justify-center px-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
      <div className="flex w-full max-w-xl flex-col gap-3 rounded-2xl border border-separator bg-overlay p-4 shadow-overlay sm:flex-row sm:items-center">
        <p className="min-w-0 flex-1 text-sm">
          May we count which pages you use, with Google Analytics, to see what to improve? Nothing you write and no names are sent.{' '}
          <a className="text-accent underline" href="https://mojoup.ai/privacy" target="_blank" rel="noreferrer">
            Privacy policy
          </a>
        </p>
        <div className="flex shrink-0 gap-2">
          <Button size="sm" variant="ghost" onPress={() => setUsageConsent('denied')}>
            No thanks
          </Button>
          <Button size="sm" variant="primary" onPress={() => setUsageConsent('granted')}>
            Allow
          </Button>
        </div>
      </div>
    </div>
  );
}
